<template>
  <div>
    <el-cascader
      v-model="value"
      :options="options"
      @change="handleChange"
    ></el-cascader>
  </div>
</template>
<script>
let items = ["00", "30",];
let time = [];
for (let index = 0; index < 24; index++) {
  let n = index < 10 ? "0" + index : index;
  for (let ind = 0; ind < items.length; ind++) {
    time.push({
      value: n + ":" + items[ind],
      label: n + ":" + items[ind],
    });
  }
}
time[16] = {
  label: "08:15",
  value: "08:15",
};
time[24] = {
  label: "11:50",
  value: "11:50",
};
time[26] = {
  label: "13:05",
  value: "13:05",
};

export default {
  model: {
    prop: "value",
    event: "click",
  },
  props: {
    formData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      value: [],
      options: [
        {
          value: "当天",
          label: "当天",
          children: time,
        },
        {
          value: "第二天",
          label: "第二天",
          children: time,
        },
      ],
    };
  },
  methods: {
    handleChange(data) {
      let text = data[0] + data[1];
      this.$emit("click", text);
    },
  },
  mounted() {
    if (this.formData.ids || this.formData.endTime) {
      let formData = { ...this.formData };
      if (formData.endTime.indexOf("天") > -1) {
        let endTime = formData.endTime.split("天");
        this.value = [endTime[0] + "天", endTime[1]];
      } else {
        let endTime = formData.endTime;
        this.value = ["当天", endTime];
      }
    }
  },
};
</script>
<style scoped>
</style>